var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvinok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 106,
    viewBox: "0 0 129 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.73 29.8321C86.709 21.8141 75.653 16.8631 63.417 16.8621C51.182 16.8631 40.128 21.8151 32.105 29.8311C24.089 37.8531 19.138 48.9081 19.136 61.1441C19.137 73.3781 24.089 84.4331 32.105 92.4551C40.127 100.473 51.182 105.423 63.417 105.425C75.652 105.423 86.709 100.473 94.73 92.4551C102.748 84.4341 107.699 73.3791 107.701 61.1441C107.699 48.9071 102.748 37.8531 94.73 29.8321Z",
    fill: "#FAB9A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.885 55.009C89.2521 55.009 93.603 50.6581 93.603 45.291C93.603 39.9239 89.2521 35.573 83.885 35.573C78.5179 35.573 74.167 39.9239 74.167 45.291C74.167 50.6581 78.5179 55.009 83.885 55.009Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.953 55.009C48.3201 55.009 52.671 50.6581 52.671 45.291C52.671 39.9239 48.3201 35.573 42.953 35.573C37.5859 35.573 33.235 39.9239 33.235 45.291C33.235 50.6581 37.5859 55.009 42.953 55.009Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.062 41.1992L128.387 26.8721L102.325 0.410156L88.914 13.7202C100.252 19.5532 109.231 29.3072 114.062 41.1992Z",
    fill: "#FAB9A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.019 13.7251L26.909 0.411133L0.557007 26.5601L14.966 40.9831C19.817 29.1911 28.755 19.5211 40.019 13.7251Z",
    fill: "#FAB9A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.073 77.262C80.073 86.46 72.615 93.912 63.418 93.912C54.222 93.912 46.765 86.458 46.765 77.262C46.765 68.059 54.222 60.604 63.418 60.604C72.615 60.604 80.073 68.061 80.073 77.262Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3411 81.6881C73.1958 81.6881 75.5101 79.3738 75.5101 76.5191C75.5101 73.6643 73.1958 71.3501 70.3411 71.3501C67.4863 71.3501 65.1721 73.6643 65.1721 76.5191C65.1721 79.3738 67.4863 81.6881 70.3411 81.6881Z",
    fill: "#FAB9A0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4991 81.6881C59.3538 81.6881 61.6681 79.3738 61.6681 76.5191C61.6681 73.6643 59.3538 71.3501 56.4991 71.3501C53.6443 71.3501 51.3301 73.6643 51.3301 76.5191C51.3301 79.3738 53.6443 81.6881 56.4991 81.6881Z",
    fill: "#FAB9A0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvinok);
export default __webpack_public_path__ + "static/media/svinok.2edc03cd6f25a7182d70b993a1e4ca5f.svg";
export { ForwardRef as ReactComponent };